<!--
 * @description: 设备管理入口页面
 * @fileName: List.vue
 * @author: fugang
 * @date: 2019-04-26 21:35:03
 * @version: V1.0.0
!-->
<template>
  <div class="summary">
    <el-row>
      <el-col v-for="(item, index) in listData" :key="index" :span="6">
        <!-- v-auth="'/cameralist/devicelist:query'" -->
        <div class="block" :title="$t('cameraList.label.clickEnter')" @click="selectDevice(item)">
          <div class="block-top">
            <div>
              <i :class="['iconfont-lunan ' + item.icon]" v-if="iconType[item.deviceTypeId]"></i>
              <i :class="['iconfont-new ' + item.icon]" v-if="iconTypeNew[item.deviceTypeId]"></i>
              <!-- <div class="type-name">{{ item.deviceTypeName }}</div> -->
            </div>
          </div>
          <div class="block-foot">
            <span>{{ item.deviceTypeName }}{{ item.deviceCount
            }}{{ $t("cameraList.label.one") }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { api } from "../api";
export default {
  data() {
    return {
      listData: [],
      iconType: {
        4: "icon-lunan-xiaofangguanli",
        18: "icon-lunan-shexiangtou",
        22: "icon-lunan-renliandaozha",
        32: "icon-lunan-dianqihuozai",
        25: "icon-lunan-daozhakongzhi",
        26: "icon-lunan-guangbo",
        30: "icon-lunan-xiaofangche",
        31: "icon-lunan-shoudongqiujiubaojing",
        33: "icon-lunan-gas",
      },
      iconTypeNew: {
        2: "iconfangqu",
        38: "icondianziweilan",
        39: "iconfengji",
        40: "iconwenshidu",
        41: "icondianbiao",
        42: "iconkongtiao",
        45: "icondianti",
        99: "iconqita",
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$fetch(api.deviceMan.queryDeviceTypeCount, {}).then((res) => {
        this.listData = res.returnObj;
        this.listData.forEach((item) => {
          item.icon =
            this.iconType[item.deviceTypeId] || this.iconTypeNew[item.deviceTypeId] || 'icon-lunan-lujing1'; //|| '
        });
      });
    },
    selectDevice(item) {
      if (item.deviceTypeId === "4") {
        // 消防
        this.$router.push({
          path: "/cameralist/fireDeviceList",
          name: "fireDeviceList",
          query: { device: item },
        });
      } else if (item.deviceTypeId === "30") {
        // 消防车
        this.$router.push({
          path: "/cameralist/fireTruckList",
          name: "fireTruckList",
          query: { device: item },
        });
      } else if (item.deviceTypeId === "31") {
        // 一建求救
        this.$router.push({
          path: "/cameralist/touchHelpList",
          name: "touchHelpList",
          query: { device: item },
        });
      } else if (item.deviceTypeId === "32") {
        // 一建求救
        this.$router.push({
          path: "/cameralist/electricDeviceList",
          name: "electricDeviceList",
          query: { device: item },
        });
      } else if (item.deviceTypeId === "33") {
        // 可燃气体
        this.$router.push({
          path: "/cameralist/gasList",
          // name: 'cameraGasList',
          query: { device: JSON.stringify(item) },
        });
      } else if (item.deviceTypeId === "99") {
        // 其它设备
        this.$router.push({
          path: "/cameralist/otherDeviceList",
          query: { device: JSON.stringify(item) },
        });
      } else {
        this.$router.push({
          path: "/cameralist/devicelists",
          name: "devicelists",
          query: { device: item },
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@src/common/assets/style/mixin";

.summary {
  display: flex;
  // padding-top: 5%;
  justify-content: center;
}

.el-row {
  width: 80%;
}

.el-col {
  padding: 0 20px;
  margin-top: 50px;
}

.block {
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.block-top {
  height: 136px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  @include set_theme_color(background-color, left-menu-bg-color);

  &:hover {
    @include set_theme_color(background-color, item-active-bg-color);

    i {
      @include set_theme_color(color, font-active-color);
    }
  }

  i {
    color: gray;
  }

  .type-name {
    margin-top: 20px;
  }
}

.block i {
  text-align: center;
  font-size: 60px;
  line-height: 1;
}

.block-foot {
  width: 100%;
  line-height: 50px;
  color: #fff;
  @include set_theme_color(background-color, main-theme-color);
}

.block div {
  text-align: center;
}
</style>
